import { Step } from 'react-joyride';

export const dashboardSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome to Swayashin! Let\'s take a quick tour of your dashboard and see how you can optimize your website\'s performance.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard-stats"]',
    content: 'This is your performance dashboard, showing your average performance score, reports generated, tasks completed, and AI solutions used.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="tasks-list"]',
    content: 'Here you can see your active performance tasks. These are automatically generated from your reports to help you improve your website.',
    placement: 'top',
  },
  {
    target: '[data-tour="tools-section"]',
    content: 'The Tools section in the sidebar gives you access to all Swayashin features, including report generation and AI-powered solutions.',
    placement: 'right',
  },
  {
    target: '[data-tour="usage-section"]',
    content: 'Track your usage statistics here, including API calls, reports generated, and remaining credits.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="ai-powered-tasks"]',
    content: 'This section highlights your AI-powered tasks. These tasks use AI to provide detailed solutions for your performance issues.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="recent-reports"]',
    content: 'See your most recent performance reports here. Each report analyzes your website and identifies areas for improvement.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="view-all-reports-link"]',
    content: 'Ready to generate more reports? Let\'s head over to the Reports page to see how you can analyze your website in detail.',
    placement: 'right',
  },
];
